<template>
  <div class="wrapper">
      <div id="cesiumContainer2" v-loading="loading"
    :element-loading-text="loadingTxt"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"></div>
	  <div class="cls-3d-pane">
		  <div id="id-3d-list">
			  <div class="cls-3d-title">站点列表</div>
			  <div class="cls-3d-body">
				  <el-table :data="querySceneList" style="width: 100%" :cell-style="cellStyle" @cell-click="onClickShowSitePosition">
					<el-table-column
						label="序号"
						type="index"
						width="50">
					</el-table-column>
					<el-table-column
						prop="siteName"
						label="站点名称"
						width="200">
					</el-table-column>
					<el-table-column
						label="操作"
						width="150">
						<template slot-scope="scope">
							<el-button size="mini" type="text"
							@click="handleEdit(scope.$index, scope.row)">编辑</el-button>
							<el-button size="small" type="text" v-if="false"
							@click.native.prevent="deleteSiteRow(scope.$index, querySceneList)">移除</el-button>
						</template>
					</el-table-column>
				  </el-table>
			  </div>
		  </div>
		  <div id="id-3d-detail">
			  <div class="cls-3d-title">详细信息
				  <el-button v-if="false"
						@click="onAddSite"
						type="primary"
						size="small" style="float:right;margin: 9px;">
						增加站点
						</el-button>
			  </div>
			  <div class="cls-3d-body" v-if="isShowSiteInfoPane">
				   <el-form :model="sceneData" ref="sceneData" label-width="80px" class="demo-ruleForm">
					<el-form-item label="站点编号" class="cls-readonly">
						<el-input v-model="sceneData.siteId" readonly="readonly"></el-input>
					</el-form-item>
					<el-form-item label="站点名称" class="cls-readonly">
						<el-input v-model="sceneData.siteName" readonly="readonly"></el-input>
					</el-form-item>
					<el-form-item label="所属乡镇" class="cls-readonly">
						<el-input v-model="sceneData.enterpriseName" readonly="readonly"></el-input>
					</el-form-item>
					<el-form-item label="三维地址">
						<el-col :span="20"><el-input v-model="sceneData.tileUrl"></el-input></el-col>
						<el-col :span="4"><el-button type="text" @click="onAdd3D">{{txtLoad3d}}</el-button></el-col>
					</el-form-item>
					<el-form-item label="二维地址">
						<el-col :span="20"><el-input v-model="sceneData.twoDimenUrl"></el-input></el-col>
						<el-col :span="4"><el-button type="text" @click="onAdd2D">{{txtLoad2d}}</el-button></el-col>
					</el-form-item>
					<el-form-item label="定位高度" prop="height" :rules="[{ type: 'number', message: '高度必须为数字值'}]">
						<el-col :span="9">
							<el-input type="number" name="height" v-model.number="sceneData.height" autocomplete="off">
								<template slot="append">米</template>
							</el-input>
						</el-col>
					</el-form-item>
					<el-col :span="12">
					<el-form-item label="x" class="cls-readonly">
						<el-input v-model="sceneData.viewX" readonly="readonly"></el-input>
					</el-form-item>
					</el-col>
					<el-col :span="12">
					<el-form-item label="y" class="cls-readonly">
						<el-input v-model="sceneData.viewY" readonly="readonly"></el-input>
					</el-form-item>
					</el-col>
					<el-col :span="12">
					<el-form-item label="z" class="cls-readonly">
						<el-input v-model="sceneData.viewZ" readonly="readonly"></el-input>
					</el-form-item>
					</el-col>
					<el-col :span="12">
					<el-form-item label="heading" class="cls-readonly">
						<el-input v-model="sceneData.heading" readonly="readonly"></el-input>
					</el-form-item>
					</el-col>
					<el-col :span="12">
					<el-form-item label="pitch" class="cls-readonly">
						<el-input v-model="sceneData.pitch" readonly="readonly"></el-input>
					</el-form-item>
					</el-col>
					<el-col :span="12">
					<el-form-item label="roll" class="cls-readonly">
						<el-input v-model="sceneData.roll" readonly="readonly"></el-input>
					</el-form-item>
					</el-col>
					<el-form-item>
						<el-button type="primary" size="mini" @click="onGetCameraParam" v-if="isEditState">提取视角</el-button>
						<el-button type="primary" size="mini" @click="onFlySiteScene">定位视角</el-button>
						<el-button type="primary" size="mini" @click="onSaveSite('sceneData')" v-if="isEditState"v>保存站点</el-button>
						<el-button type="primary" size="mini" @click="onAddDev" v-if="sceneData.siteId && false">新增设备</el-button>
					</el-form-item>
					<div>设备列表</div>
					<div class="cls-iot-body">
						<el-row :ref="`iot_dev${index}`" :key="index" v-for="(item,index) in sceneData.devList" 
						     class="cls-dev-content">
							<el-col :span="4"><div class="cls-dev-index">{{index+1}}</div></el-col>
							<el-col :span="20">
								<el-form-item label="设备编号" size="mini" class="cls-readonly">
									<el-input v-model="item.devId" size="mini"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="20" :offset="4">
								<el-form-item label="设备名称" size="mini" class="cls-readonly">
									<el-input v-model="item.devName" size="mini"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="20" :offset="4">
								<el-form-item label="设备坐标" size="mini" class="cls-readonly">	
									<el-col :span="12">
										<el-input v-model="item.x" readonly="readonly" placeholder="经度" size="mini"></el-input>
									</el-col>
									<el-col :span="12">
										<el-input v-model="item.y" readonly="readonly" placeholder="纬度" size="mini"></el-input>
									</el-col>
								</el-form-item>
							</el-col>
							<el-col :span="20" :offset="4">
									<el-button size="mini" type="text" v-if="item.x && item.y" @click="onFlyDevPoint(index)">定位设备</el-button>
									<el-button size="mini" type="text" v-if="isEditState" @click="onGetMapPoint(index)">位置标点</el-button>
									<el-button size="mini" type="text" @click="onDelDev(index, sceneData.devList)" v-if="false">删除设备</el-button>
									<el-button size="mini" type="text" v-if="isEditState" @click="onSaveDev(index)">保存设备</el-button>
							</el-col>
						</el-row>
					</div>
				   </el-form>
			  </div>
		  </div>
	  </div>
  </div>
</template>

<script>
import * as  Cesium from  'cesium/Cesium';
import widgets from 'cesium/Widgets/widgets.css';
import pointImg from "@/assets/3d/point/point1.png";
import pointImgChecked from "@/assets/3d/point/point3.png";
import {getWarnsUser} from "@/api/configuration/user";
import {selectRealSceneData, addOrEditRealData, deleteRealData, addOrEditDevice, deleteDevice} from "@/api/3d/iotReq";

export default {

  data(){
    return {
		loading: false,  //加载数据时显示动效
		loadingTxt: '',
		maploadingevent: false,  //地图是否正在请求
		pointDraged: null,//拖拽的对象
		leftDownFlag: false,  //是否鼠标左键已经按下

		sceneData : {},
		viewer: null,
		isShowSiteInfoPane: false, //是否显示站点信息面板
		isEditState: false,  //是否编辑状态
		txtLoad3d: '叠加',   //是否加载三维场景
		txtLoad2d: '叠加',   //是否加载地图 
		myPrimitive: null,
		myImageryLayer: null,
		querySceneList: [],    //查询结果列表
		pointArr: [],   //图上点的集合
		queryPage: 0,   //查询页数
		index_point : -1  //当前采集点位序号
    }
  },

  methods:{
      init(){
			console.log('----初始化地球----');
			var Cesium = this.Cesium;
			//Cesium.Ion.defaultAccessToken='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIyMjJjMzI5YS1jZWRkLTQ1YTEtOTIzMy1lNDlmNmQyM2M0YmYiLCJpZCI6MzM2NjksImlhdCI6MTU5OTA1MDM1MH0.Aofdn9ZlfkxQl7W7F-O2XKrz5Ga8hWooRj-CkHuXeEs';
			//debugger
			this.viewer = new Cesium.Viewer('cesiumContainer2',{
				baseLayerPicker:false,
				timeline:false,
				homeButton:false,
				fullscreenButton:false,
				infoBox:false,
				sceneModePicker:false,
				navigationInstructionsInitiallyVisible:false,
				navigationHelpButton:false,
				geocoder:false,
				animation:false,
				selectionIndicator:false,
				creditsDisplay: false
			});
			this.viewer.cesiumWidget.creditContainer.style.display = 'none';
			this.viewer.scene.postProcessStages.fxaa.enabled = false;
			this.viewer.scene.globe.enableLighting = true;
			this.viewer.scene.globe.depthTestAgainstTerrain = true;
			
			//加载谷歌地图
			this.loading = true;
			var gog=new Cesium.UrlTemplateImageryProvider({
				url:"http://mt1.google.cn/vt/lyrs=s&hl=zh-CN&x={x}&y={y}&z={z}&s=Gali"});
			this.viewer.imageryLayers.addImageryProvider(gog);

			this.moveToHubei();
			this.handlerMapClickEvent();
			this.querySiteList();

			let me = this;
			var helper = new Cesium.EventHelper();
			helper.add(this.viewer.scene.globe.tileLoadProgressEvent, function (event) {
				//console.log('---event-----', event);
				me.loadingTxt = '地图正在加载！'+event;
				me.maploadingevent = true;
				if (event == 0) {
					me.loading = false;
					me.maploadingevent = false;
					console.log('这个是加载最后一个矢量切片的回调');
				}
			});
			//处理鼠标拖拽
			this.viewer.screenSpaceEventHandler.setInputAction(me.leftDownAction, Cesium.ScreenSpaceEventType.LEFT_DOWN);
			this.viewer.screenSpaceEventHandler.setInputAction(me.leftUpAction, Cesium.ScreenSpaceEventType.LEFT_UP);
			this.viewer.screenSpaceEventHandler.setInputAction(me.mouseMoveAction, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

		},

		moveToHubei(){
			console.log('----移动地图到湖北----');
			var viewPoint = {x: -2264706.893116936, y: 5430025.26103238, z: 3415803.598998195};
			var hcv = {
				destination: viewPoint,
				orientation: {
					heading : 6.2831853071, 
					pitch : -1.568643548, 
					roll : 0
				}
			}
			this.viewer.camera.flyTo(hcv);
		},

		querySiteList(){
			console.log('----请求站点列表数据----');
			//测试数据
			var resData = [{"tileUrl":"http://www.is51.cn:9001/data_cesium/颜闸村/倾斜/tileset.json",
					"viewX":-2109972.236535511,"viewY":5109465.627192092,"viewZ":3171161.404941637,
					"heading":3.7894661189281797,"roll":0.0,"siteName":"颜闸村丰泽园",
					"devList":[{id:'1', "devId":"1020FF01D3A100A0","x":112.4373,"y":30.0058,"devName":"大棚采集站"},
					{id:'2', "devId":"0007C802D4A100F2","x":112.43775,"y":30.0066,"devName":"气象站"},
					{id:'3', "devId":"1021FF01D4A100F2","x":112.43785,"y":30.006,"devName":"气象采集"}],
					"siteId":114,"twoDimenUrl":"http://www.is51.cn:9000/data_cesium/颜闸村/影像/{z}/{x}/{y}.png",
					"pitch":-0.6252599765489384,"enterpriseName":"荆州市江陵县郝穴镇","height":50},
				{"tileUrl":"http://www.is51.cn:9001/data_cesium/何岗村/倾斜/tileset.json",
					"viewX":-2055967.123034465,"viewY":5000563.175663621,"viewZ":3372662.936400341,
					"heading":5.998537397952983,"roll":0.0,"siteName":"何岗村测试",
					"devList":[{id:'4', "devId":"0007C80285A20088","x":112.34916,"y":32.13125,"devName":"襄阳项目"},
					{id:'5', "devId":"100AFF0385A20088","x":112.34937,"y":32.13306,"devName":"四合一"}],
					"siteId":117,"twoDimenUrl":"http://www.is51.cn:9000/data_cesium/何岗村/影像/{z}/{x}/{y}.png",
					"pitch":-0.6109584376625801,"enterpriseName":"荆州市江陵县郝穴镇","height":100}
			];
			//-------------------------------logic----------------------------------
			getWarnsUser().then(res => {
				this.querySceneList = res.siteList;
			}).catch(error => {});
		},

		onClickShowSitePosition(row, column, cell, event){
			console.log(row, column);
			if(column.property == "siteName"){
				console.log("----请求三维场景数据 查看----", row.siteId);
				
				this.loading = true;
				selectRealSceneData({siteId: row.siteId}).then(res => {
					console.log("----接收后台数据----", res.data);
					
					if (res.code === 200) {
						if (res.data) {
							this.sceneData = res.data;

							this.isShowSiteInfoPane = true;
							this.isEditState = false;
							this.flyTo(this.sceneData);
							this.clearAll();
							this.showPoint(this.sceneData.devList);
						} 
					}
					if(this.maploadingevent){
						this.loading = true;
					}else{
						this.loading = false;
					}
				});
			}
		},

		handleEdit(index, row) {
			console.log(index, row);
			console.log("----请求三维场景数据 修改----", row.siteId);
			this.loading = true;
			
			selectRealSceneData({siteId: row.siteId}).then(res => {
				console.log("----接收后台数据----", res.data);

				if (res.code === 200) {
					if (res.data) {
						this.sceneData = res.data;

						this.isShowSiteInfoPane = true;
						this.isEditState = true;
						this.flyTo(this.sceneData);
						this.clearAll();
						this.showPoint(this.sceneData.devList);
					}
				}
				if(!this.maploadingevent){
						this.loading = false;
				}
			});
		},

		onAddSite(){
			this.isShowSiteInfoPane = true;
			this.isEditState = true;
			this.sceneData = {"tileUrl":"",
				"viewX":null,"viewY":null,"viewZ":null,
				"heading":null,"roll":null,"siteName":"",
				"devList":[],
				"siteId":'',"twoDimenUrl":"",
				"pitch":null,"enterpriseName":"","height":null};
		},
		
		onSaveSite(formName){
			this.$refs[formName].validate((valid) => {
				console.log('valid',valid)
				if (valid) {
					//-----------------------logic-------------------------
					var me = this;
					addOrEditRealData(me.sceneData).then(res => {
						console.log('----ret', res.data);
						if(res.code === 200){
							var _action_type = '修改';
							if(!me.sceneData.siteId){
								me.sceneData.siteId = res.data;
								_action_type = '新增';
								//this.querySceneList.push(this.sceneData);
							}
							me.$notify({
								title: '成功',
								message: _action_type + '站点信息成功！',
								position: 'top-left',
								type: 'success'
							});
						}
					});
				} else {
					this.$notify({
								title: '提交失败',
								message: '高度设置不正确，请重新设置！',
								position: 'top-left',
								type: 'success'
							});
					return false;
				}
			});
		},

		deleteSiteRow(index, rows) {
			this.$confirm('此操作将永久删除该站点信息, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				//--------------logic----------------
				console.log('----index---',index);
				var me = this;
				deleteRealData(rows[index].siteId).then(res => {
					if(res.code == '200'){
						me.$message({
							type: 'success',
							message: '删除成功!'
						});
					}
				});
				rows.splice(index, 1); //
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});          
			});
		},

		onAdd3D(){
			if(this.txtLoad3d == '叠加'){
				this.txtLoad3d = '移除';
				this.txtLoad2d = '叠加';
				this.show3d(this.sceneData);
				this.hide2d();
			}else{
				this.txtLoad3d = '叠加';
				this.txtLoad2d = '叠加';
				this.hide3d();
				
			}
		},

		onAdd2D(){
			if(this.txtLoad2d == '叠加'){
				this.txtLoad2d = '移除';
				this.txtLoad3d = '叠加';
				this.show2d(this.sceneData);
				this.hide3d();
			}else{
				this.txtLoad2d = '叠加';
				this.txtLoad3d = '叠加';
				this.hide2d();
				
			}
		},

		onGetCameraParam(){
			this.sceneData.viewX = this.viewer.camera.position.x;
			this.sceneData.viewY = this.viewer.camera.position.y;
			this.sceneData.viewZ = this.viewer.camera.position.z;
			this.sceneData.heading = this.viewer.camera.heading;
			this.sceneData.pitch = this.viewer.camera.pitch;
			this.sceneData.roll = this.viewer.camera.roll;
			console.log(this.viewer.camera.position, this.viewer.camera.heading, this.viewer.camera.pitch, this.viewer.camera.roll);
		},

        onFlySiteScene(){
			this.flyTo(this.sceneData);
		},

		flyTo(data){
			if(data.viewX && data.viewY && data.viewZ){
				var viewPoint = {x: data.viewX, y: data.viewY, z: data.viewZ};
				//Cesium.Cartesian3.fromDegrees(112.43750875265964,30.005589995975487, 100);
				var hcv = {
					destination: viewPoint,
					orientation: {
						heading : data.heading, //Cesium.Math.toRadians(0.0),
						pitch : data.pitch, //Cesium.Math.toRadians(-35.0),
						roll : data.roll
					}
				}
				// this.loading = true;
				//viewer.camera.setView(hcv);
				this.viewer.camera.flyTo(hcv);
			}else{
				this.loading = false;
			}
		},

		showPoint(data){
			this.hidePoint();
			for( var i in data){
				this.pointArr.push(this.initPoint(data[i], i));
			}
		},
		
		initPoint(item, index){console.log(item.devName);
			if(item.x && item.y){
				var point = this.viewer.entities.add({
					id:item.devId,pointindex: index,
					name : item.devName,
					position:Cesium.Cartesian3.fromDegrees(item.x,item.y, 0),
					
					billboard:{
						image: pointImg,
						width: 38,
						height: 50,
						scaleByDistance: new Cesium.NearFarScalar(100, 1.0, 1e4, 0.5),
						//scale: 1//,//0.6,
						heightReference : Cesium.HeightReference.CLAMP_TO_GROUND
					},
					label:{
						text:item.devName,
						font:'14px sans-serif',
						style: Cesium.LabelStyle.FILL_AND_OUTLINE,
						fillColor: Cesium.Color.AQUAMARINE,
						backgroundColor: new Cesium.Color(0, 0, 0, .9),
					//    clampToGround:false,
						//scale: 0.8,
						horizontalOrigin : Cesium.HorizontalOrigin.CENTER,
						verticalOrigin : Cesium.VerticalOrigin.BOTTOM,
						disableDepthTestDistance: 100.0,
						pixelOffset:new Cesium.Cartesian2(0, -30),
						//heightReference : Cesium.HeightReference.RELATIVE_TO_GROUND,
						showBackground:true
					}
				});
				
				// //line
				// var position1 = Cesium.Cartesian3.fromDegrees(item.x,item.y, this.sceneData.height||100);
				// var position2 = Cesium.Cartesian3.fromDegrees(item.x,item.y,0);
				// this.viewer.entities.add({
				// 	polyline: {
				// 		positions: [position1, position2],
				// 		clampToGround: false,
				// 		//material: Cesium.Color.RED,
				// 		width: 1
				// 	}
				// });
				return point;
			}
			return null;
		},

		hidePoint(){
			this.viewer.entities.removeAll();//清空所有模型
			this.pointArr = [];
		},

		show3d(data){
			console.log('----加载村场景----', data.tileUrl);
			if(data.tileUrl){
				this.loading = true;
				this.myPrimitive = new Cesium.Cesium3DTileset({
					url: data.tileUrl,
					visibleRange : { max: 22000 },
					dynamicScreenSpaceError : true,
					dynamicScreenSpaceErrorDensity : 0.00278,
					dynamicScreenSpaceErrorFactor : 4.0,
					dynamicScreenSpaceErrorHeightFalloff : 0.25,
					maximumScreenSpaceError : 50,
					maximumNumberOfLoadedTiles : 50000
				});
				this.viewer.scene.primitives.add(this.myPrimitive);

				var me = this;
				this.myPrimitive.allTilesLoaded.addEventListener(function() {
					console.log('----加载村场景 完成----');
					me.loading = false;
				});

			}
			
		},

		hide3d(){
			if(this.myPrimitive){
				this.viewer.scene.primitives.remove(this.myPrimitive);
				this.myPrimitive = null;
			}
		},

		show2d(data){
			if(data.twoDimenUrl){
				this.loading = true;
				this.myImageryLayer = this.viewer.imageryLayers.addImageryProvider(
					new Cesium.UrlTemplateImageryProvider({url: data.twoDimenUrl}));
			}
		},

		hide2d(){
			if(this.myImageryLayer){
				var ret = this.viewer.imageryLayers.remove(this.myImageryLayer);
				this.myImageryLayer = null;
			}
		},

//--------------------dev-------------------

		onAddDev(){
			this.sceneData.devList.push({"devId":"","x":null,"y":null,"devName":""});
		},

		onSaveDev(index){
			console.log(index);
			this.index_point = -1;
			if(!this.sceneData.siteId){
				this.$alert('请先保存站点信息，再保存设备信息！', '警告', {
				confirmButtonText: '确定'
				});
				return;
			}
		   //--------------------logic---------------------
			var me = this;
		    addOrEditDevice(this.sceneData.devList[index]).then(res => {
				if(res.code == '200'){
					var _action_type = '修改';
					if(!me.sceneData.devList[index].id){
						me.sceneData.devList[index].id = res.data;
						_action_type = '新增';
					}
					me.$notify({
						title: '成功',
						message: _action_type + '设备信息成功！',
						position: 'top-left',
						type: 'success'
					});
				}
			});

		},

		onDelDev(index, devList){
			this.$confirm('此操作将永久删除该设备信息, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				//--------------logic----------------
				var me = this;
                deleteDevice(devList[index].id).then(res => {
					if(res.code === '200'){
						me.$message({
							type: 'success',
							message: '删除成功!'
						});
						devList.splice(index, 1); //
					}
				});


			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});          
			});
		},

		onGetMapPoint(index){
			console.log(index);
			this.index_point = index;
			console.log(this.$refs[`iot_dev${index}`]);
			console.log(this.$refs['iot_dev'+index][0].$el);
			let eleArr = document.getElementsByClassName('cls-dev-content');
			for(var i=0;i<eleArr.length;i++){
				eleArr[i].style.backgroundColor = 'initial';//
				//console.log(i, eleArr[i]);
			}
			this.$refs['iot_dev'+index][0].$el.style.backgroundColor = '#67C23A';
			document.getElementById('cesiumContainer2').style.cursor = 'crosshair';
		},

		onFlyDevPoint(index){
			console.log(this.sceneData.devList[index]);
			var _dev = this.sceneData.devList[index];
			if(!_dev.x || !_dev.y){
				this.$message({
					type: 'info',
					message: '该设备未采集坐标，不能定位！'
				}); 
				return;
			}
			var position = Cesium.Cartesian3.fromDegrees(_dev.x,_dev.y, 0);
			this.viewer.scene.camera.setView({
				destination: position,
				orientation: {
					heading: this.sceneData.heading,
					pitch : this.sceneData.pitch
				}
			});
			this.viewer.scene.camera.moveBackward(100);
		},

		cellStyle({row, column, rowIndex, columnIndex}){
			return "padding: 0px 2px;";
		},


//处理地图事件
        handlerMapClickEvent(){
			var me = this;
			//单击事件
			var handler = new Cesium.ScreenSpaceEventHandler(me.viewer.scene.canvas);
			//调用setInputAction方法
			handler.setInputAction(function(movement){
				
				var cartesian = me.viewer.camera.pickEllipsoid(movement.position, me.viewer.scene.globe.ellipsoid);
				if(cartesian){
					//将笛卡尔三维坐标转为地图坐标（弧度）
					var cartographic = me.viewer.scene.globe.ellipsoid.cartesianToCartographic(cartesian);
					//将地图坐标（弧度）转为十进制的度数
					var lat=Cesium.Math.toDegrees(cartographic.latitude);
					var lon=Cesium.Math.toDegrees(cartographic.longitude);
					lat = Number(Number(lat).toFixed(5));
					lon = Number(Number(lon).toFixed(5));
					console.log(lon, lat);
					if(me.index_point>-1){
						// create point
						var item = me.sceneData.devList[me.index_point];
						if(item.x && item.y){// 有坐标
							// move
							item.x = lon;
							item.y = lat;
							me.pointArr[me.index_point].position = cartesian;
						}else{
							// create
							item.x = lon;
							item.y = lat;
							console.log(me.index_point,item,'-----');
							me.pointArr[me.index_point] = me.initPoint(item, me.index_point);
						}

						document.getElementById('cesiumContainer2').style.cursor = 'default';
						me.index_point = -1;
					}
				}
				
			},Cesium.ScreenSpaceEventType.LEFT_CLICK);
		},

		clearAll(){
			this.hide3d();
			this.hide2d();
			this.hidePoint();
			this.txtLoad3d = '叠加';
			this.txtLoad2d = '叠加';
			let eleArr = document.getElementsByClassName('cls-dev-content');
			for(var i=0;i<eleArr.length;i++){
				eleArr[i].style.backgroundColor = 'initial';//
			}
			this.index_point = -1;
		},

		leftDownAction(e) {
			if(!this.isEditState){
				return;
			}
			console.log("左键按下");
			this.pointDraged = this.viewer.scene.pick(e.position);//选取当前的entity
			this.leftDownFlag = true;
			if (this.pointDraged) {
				console.log(this.pointDraged);
				this.pointDraged.id.billboard.image = pointImgChecked;
				this.viewer.scene.screenSpaceCameraController.enableRotate = false;//锁定相机
			}
		},

		leftUpAction(e) {
			if(!this.isEditState){
				return;
			}
			console.log("左键抬起");
			if(this.pointDraged)
			this.pointDraged.id.billboard.image = pointImg;
			this.leftDownFlag = false;
			this.pointDraged=null;
			this.viewer.scene.screenSpaceCameraController.enableRotate = true;//解锁相机
			
		},

		mouseMoveAction(e) {
			if(!this.isEditState){
				return;
			}
			if (this.leftDownFlag && this.pointDraged) {
				console.log("鼠标移动", this.pointDraged.id.id, this.pointDraged.id.pointindex);
				let ray = this.viewer.camera.getPickRay(e.endPosition);
				let cartesian = this.viewer.scene.globe.pick(ray, this.viewer.scene);
				if(cartesian){
					//将笛卡尔三维坐标转为地图坐标（弧度）
					var cartographic = this.viewer.scene.globe.ellipsoid.cartesianToCartographic(cartesian);
					//将地图坐标（弧度）转为十进制的度数
					var lat=Cesium.Math.toDegrees(cartographic.latitude);
					var lon=Cesium.Math.toDegrees(cartographic.longitude);
					console.log(lon, lat);
					if(this.pointDraged.id.pointindex > -1){
						this.sceneData.devList[this.pointDraged.id.pointindex].x = Number(lon).toFixed(5);//lon;
						this.sceneData.devList[this.pointDraged.id.pointindex].y = Number(lat).toFixed(5);//lat;
					}
					console.log(cartesian);
					if(this.pointDraged.id){
						this.pointDraged.id.position = cartesian;//此处根据具体entity来处理，也可能是pointDraged.id.position=cartesian;
					}
				}
			}
		}

    },
    created(){},
	mounted(){
		this.init();
	},
  	beforeDestroy() {
		//离开当前页面后执行
		console.log('离开当前页面后执行');
		this.clearAll();
    }
}
</script>
<style>
.cls-readonly .el-input__inner {background-color:initial !important;border: initial !important;}
.cls-dev-index {background-color: white; color:black;border-radius:50%; margin:5px auto;width: 20px;}
</style>
<style lang="scss" scoped>
.wrapper{height:100%;width:100%;margin: 0; padding: 0; width:100%; position: relative;}
#cesiumContainer2{height:100%; width:100%;}
.cls-3d-pane{position: absolute; left:0px; top: 0px; width:400px; height:100%; background-color: #00122b; opacity: 0.8;
	color: white;}
.cls-3d-title{color:rgb(255, 255, 255); font-size:15px; text-align:left; padding-left: 10px;
	height: 50px; line-height: 50px; background-color: rgb(142,167,221);}
#id-3d-list td {padding: 0px;}
.cls-3d-body .el-form-item__label {line-height: 20px;}

.cls-3d-body .el-form-item { margin-bottom: 0px;}
.cls-dev-content {margin: 5px; border-top: 1px dashed #555;}
.cls-iot-body{overflow: auto; height: 300px;}


</style>